export default __webpack_public_path__ + "static/media/gallery_09.1ae103ca.jpg";